import React, {createContext, useContext, useReducer} from 'react';

// Definition the actions
export const CUSTOMER_ACTIONS = {
    UPDATE_ALL: 'UPDATE_ALL',
    ADD_DOSSIER: 'ADD_DOSSIER'
};

// Creation of the context with a more complete default value
const CustomerContext = createContext(null);
// Update of tje auth data with dispatch
const CustomerDispatchContext = createContext(null);

// Provider of the context that will share the dispatch function
export function CustomerProvider({ defaultCustomer, children }) {
    const [customer, dispatch] = useReducer(customerReducer, defaultCustomer ? defaultCustomer : {});

    return (
        <CustomerContext.Provider value={customer}>
            <CustomerDispatchContext.Provider value={dispatch}>
                {children}
            </CustomerDispatchContext.Provider>
        </CustomerContext.Provider>
    );
};


function customerReducer(customer, action) {
    switch (action.type) {
        case CUSTOMER_ACTIONS.UPDATE_ALL: {
            return action.payload;
        }
        case CUSTOMER_ACTIONS.ADD_DOSSIER: {
            const { dossier } = action.payload;
            const { dossiers = [] } = customer;

            let updatedDossiers = [...dossiers, dossier];

            return {
                ...customer,
                dossiers: updatedDossiers
            }
        }
        default:
            return customer;
    }
}

// Creation of a hook to use the context in a component
export function useCustomer() {
    return useContext(CustomerContext);
};

// Creation of a hook to use the context in a component
export function useCustomerDispatch() {
    return useContext(CustomerDispatchContext);
};